import React from "react";
import {DEFAULT_CRITERIA_REPORT_CONTEXT} from "../constants/commons";
import {ICriteriaReportContext} from "../models/CriteriaModels";

export const CriteriaReportContext = React.createContext<ICriteriaReportContext>(DEFAULT_CRITERIA_REPORT_CONTEXT);

export const CriteriaReportProvider = CriteriaReportContext.Provider;

export const useCriteriaReportContext = () => React.useContext(CriteriaReportContext);
